const colors = {
  gray: {
    50: "#F6F6F6",
    200: "#E4E4E4",
    300: "#C2C2C2",
    400: "#959595",
    500: "#676767",
  },
  orange: {
    500: "#EA6A1F",
  },
}

export default colors
